var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticClass:"brand-logo"},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.brand}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }